import { useTranslation } from "../../../../localization/useTranslation.ts";
import { useExcludeAccessDialog } from "./ExcludeAccessDialog.hooks.ts";
import { DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";

export interface ExcludeAccessDialogProps {
    systemId: string;
    userId: string;
    userFullName: string;

    onCloseDialog: () => void;
    onAccessExcluded: () => void;
}

function ExcludeAccessDialog(props: ExcludeAccessDialogProps) {
    const { translateString } = useTranslation();
    const { inProgress, onExcludeAccess } = useExcludeAccessDialog(props);

    return (
        <DotLegalDeleteDialog
            open
            headerText={translateString("excludeAccess")}
            alertBodyText={translateString("excludeSystemAccessWarningText", { fullName: props.userFullName })}
            warningTranslation={translateString("excludeAccess")}
            deleteBtnText={translateString("excludeAccess")}
            cancelBtnText={translateString("cancel")}
            onDialogClose={() => props.onCloseDialog()}
            onOkClick={() => onExcludeAccess()}
            inProgress={inProgress}
        />
    );
}

export default ExcludeAccessDialog;
